import React from 'react';

/**
 * The value `Approval.js` puts on the provider, key for key.
 *
 * Every member is `any` rather than a real type: the sole provider is
 * `Approval.js`, a plain `.js` file, so each of these values is already `any`
 * before it reaches the context and nothing more precise can be recovered here.
 * Declaring the *keys* is what matters — without them the context is
 * `Context<{}>` and every read in the eight consuming components is an error.
 * Tightening the member types is possible only after `Approval.js` itself is
 * typed; see docs/development/typecheck-baseline-followups.md.
 *
 * @typedef {{
 *   bundles: any,
 *   canExclusivityBeSelected: any,
 *   flow: any,
 *   group: any,
 *   groupPayment: any,
 *   guaranteedTimeToList: any,
 *   homeownerPayment: any,
 *   homeownerReportPayment: any,
 *   inspectionType: any,
 *   isComplimentaryRepairsExclusivitySelected: any,
 *   isDoNotExceedGroup: any,
 *   isLegacyInvoicing: any,
 *   isNewProjectManagementFee: any,
 *   isSubmitting: any,
 *   loader: any,
 *   mainPointOfContactEmployee: any,
 *   maximumMonthlyPaymentPlan: any,
 *   onApprovalStepSubmit: any,
 *   onImprovementToggle: any,
 *   onNext: any,
 *   onRefreshStepData: any,
 *   onSave: any,
 *   priceRange: any,
 *   reusablePros: any,
 *   rewards: any,
 *   setIsSubmitting: any,
 *   showTimer: any,
 *   supportsExecutionMode: any,
 *   upfrontPayment: any,
 *   usesPayAsYouGoBilling: any,
 * }} ApprovalContextValue
 */

export const ApprovalContext = React.createContext(
  /** @type {ApprovalContextValue} */ ({}),
);
